function Onboarding({ form, step, error, saving, updateField, nextStep, prevStep, finishOnboarding }) {
  return (
    <main className="screen onboarding-screen">
      <section className="onboarding-card">
        <p className="eyebrow">Programa de Calistenia Militar</p>
        <h1>Configura tu plan</h1>
        <p className="subtitle">Responde 3 pasos y te muestro tu entrenamiento del dia.</p>

        <div className="step-indicator">
          <span className={step >= 0 ? 'active' : ''}>1</span>
          <span className={step >= 1 ? 'active' : ''}>2</span>
          <span className={step >= 2 ? 'active' : ''}>3</span>
        </div>

        {step === 0 && (
          <div className="question-block">
            <label>
              Nombre completo
              <input
                value={form.fullName}
                onChange={(event) => updateField('fullName', event.target.value)}
                placeholder="Ej: Carlos Ramirez"
                autoFocus
              />
            </label>
          </div>
        )}

        {step === 1 && (
          <div className="question-block">
            <label>
              Edad
              <input
                type="number"
                inputMode="numeric"
                value={form.age}
                onChange={(event) => updateField('age', event.target.value)}
              />
            </label>
            <label>
              Peso (kg)
              <input
                type="number"
                inputMode="numeric"
                value={form.weightKg}
                onChange={(event) => updateField('weightKg', event.target.value)}
              />
            </label>
            <label>
              Altura (cm)
              <input
                type="number"
                inputMode="numeric"
                value={form.heightCm}
                onChange={(event) => updateField('heightCm', event.target.value)}
              />
            </label>
          </div>
        )}

        {step === 2 && (
          <div className="question-block">
            <label>
              Nivel
              <select value={form.level} onChange={(event) => updateField('level', event.target.value)}>
                <option value="principiante">Principiante</option>
                <option value="intermedio">Intermedio</option>
                <option value="avanzado">Avanzado</option>
              </select>
            </label>

            <label>
              Dias por semana
              <select
                value={form.daysPerWeek}
                onChange={(event) => updateField('daysPerWeek', Number(event.target.value))}
              >
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
              </select>
            </label>

            <label>
              Objetivo
              <textarea value={form.goal} onChange={(event) => updateField('goal', event.target.value)} />
            </label>
          </div>
        )}

        {error && <p className="error-text">{error}</p>}

        <div className="actions">
          {step > 0 && (
            <button type="button" className="secondary" onClick={prevStep}>
              Atras
            </button>
          )}

          {step < 2 ? (
            <button type="button" className="primary" onClick={nextStep}>
              Siguiente
            </button>
          ) : (
            <button type="button" className="primary" onClick={() => void finishOnboarding()} disabled={saving}>
              {saving ? 'Guardando...' : 'Crear plan'}
            </button>
          )}
        </div>
      </section>
    </main>
  )
}

export default Onboarding
